<template>
  <div>
    <menu-superior class="waves-effect" id="menusuperior-grupo" :titulo="grupo.grupo.nome.toUpperCase()" :colorarrow="this.cor_grupo" :style="'font-weight: bold;background-color:white;border-style: solid;border-width: 1px;border-color: '+ this.cor_grupo +'; background-color: '+ this.cor_grupo_fundo + ';color:'+ this.cor_grupo"></menu-superior>
    <br>
    <br>

    <div class="container">
      <div class="nav-content nav-content-s" @click="Pesquisar()">
        <div class="nav-wrapper">
          <nav>
            <div class="nav-wrapper">
              <form>
                <div class="input-field"
                      :style="'background-color:white;border-style: solid;border-width: 1px;border-color: '+ this.$store.state.empresa.cor_primaria+';color:'+ this.$store.state.empresa.cor_primaria ">
                  <input id="search" type="search" required placeholder="O que você procura?">
                  <label class="label-icon" for="search" :style="'color:'+ this.$store.state.empresa.cor_primaria "><i
                    class="material-icons"
                    :style="'color:'+ this.$store.state.empresa.cor_primaria ">search</i></label>
                  <i class="material-icons">close</i>
                </div>
              </form>
            </div>
          </nav>
        </div>
      </div>
    </div> 
    <br>
    <div v-for="item in this.grupo.secoes"  :id="'secao-'+item.detalhes.id" class="container page-section">
      <titulo-destacado :fundo="'white'" :titulo="item.detalhes.nome.toLocaleUpperCase()" :id="'titulo_destacado_grupo_secao_'+item.detalhes.id"></titulo-destacado>
      <div class="row" style="margin-top: 10px">
        <card v-for="produto in item.itens" :produto="produto" :key="'itempromocao-'+produto.id" ></card>
      </div>
    </div>
    <meu-pedido-bloco-flutuante-component></meu-pedido-bloco-flutuante-component>
  </div>
</template>

<script>
import TituloDestacado from "../Widgets/TituloDestacado";
import Item from "../Widgets/Item";
import MenuSuperior from "../Widgets/MenuSuperior";
import SecureLS from "secure-ls";
import Card from "../Widgets/Produto/Card";
import MeuPedidoBlocoFlutuanteComponent from "../Widgets/MeuPedidoBlocoFlutuanteComponent";

export default {
  name: "Grupo",
  data() {
    return {
      grupo: null,
      corPrimaria: this.$store.state.empresa.cor_primaria,
      corSecundaria: this.$store.state.empresa.cor_secundaria,
      cor_grupo_fundo: this.$store.state.empresa.cor_grupo_fundo,
      cor_grupo: this.$store.state.empresa.cor_grupo,
      cor_secao_fundo: this.$store.state.empresa.cor_secao_fundo,
      cor_secao: this.$store.state.empresa.cor_secao,
      termoBusca: '',
      produtos: [],
      produtosFiltro: [],
    }
  },
  components: {MeuPedidoBlocoFlutuanteComponent, Card, MenuSuperior, Item, TituloDestacado},
  created() {
    var ls = new SecureLS();
    this.grupo = ls.get('grupo');
  },
  mounted() {
    if (this.$store.state.empresa.cor_primaria == undefined) {

      let grupoLink = '';
      try {
        if (this.$route.query.grupo) {
          grupoLink = '?grupo=' + this.$route.query.grupo;
        }
      } catch (exception) {
      }
      this.$router.push('/' + this.$router.currentRoute.params.empresa + '/menu' + grupoLink)

    }

    if (this.$router.currentRoute.params.id != 0) {
      var elmnt = document.getElementById('secao-' + this.$router.currentRoute.params.id);
      elmnt.scrollIntoView(true);
      window.scrollBy(0, -0);
    } else {
      var elmnt = document.getElementById('menusuperior-grupo');
      elmnt.scrollIntoView(true);
      window.scrollBy(0, -0);
    }

    setTimeout(res=>{
      this.grupo.secoes.forEach(item=>{
        document.getElementById('titulo_destacado_grupo_secao_'+item.detalhes.id).style = 'border-style: solid;border-width: 1px;border-color: '+ this.cor_secao +'; background-color: '+ this.cor_secao_fundo + ';color:'+ this.cor_secao;
        this.produtosFiltro = item;
      })
      this.produtos       = Item;
    },1)
  },
  methods: {
    Voltar() {
      this.$router.back();
    },
    Pesquisar() {
      this.$router.push('/' + this.$store.state.empresa_url + '/menu/pesquisar')
    }  
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Paginas/Grupo.vue